import { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'


class Permission extends Component {
  /* LIFECYCLE */

  /**
   * @componentWillReceiveProps
   * @param {*} nextProps - Next properties of the Component
   */
  componentWillReceiveProps(nextProps) {
    const { user, location } = nextProps

    if (!user && user !== this.props.user && location.pathname !== '/') {
      this.props.history.push('/')
    }
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    return this.props.children
  }
}


Permission.propTypes = {
  user: PropTypes.object,
  children: PropTypes.node,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
}


const mapStateToProps = state => ({
  user: state.user.data,
})


export default withRouter(connect(mapStateToProps)(Permission))
